// useProductosEtiquetaXL - S47.3a.
// Wrapper de solo lectura sobre useProductosListXL del modulo productos_xl.
// Expone solo lo necesario para el ProductoPicker del editor de etiquetas:
// items (lista paginada), loading, error. NO toca productos_xl, solo
// importa y re-emite. Filtros (q) opcionales para busqueda en el picker.
import { useEffect, useMemo, useRef } from 'react';
import useProductosListXL from '../../productos_xl/hooks/useProductosListXL';

const PER_PAGE_PICKER = 100;

export default function useProductosEtiquetaXL() {
  const inner = useProductosListXL();

  // En el primer mount, subir perPage para que el picker tenga mas opciones
  // sin paginacion. El hook interno re-dispara load() automaticamente.
  const bumped = useRef(false);
  useEffect(() => {
    if (bumped.current) return;
    bumped.current = true;
    if (typeof inner.setPerPage === 'function') {
      inner.setPerPage(PER_PAGE_PICKER);
    }
  }, [inner]);

  const items = useMemo(() => {
    const arr = Array.isArray(inner.items) ? inner.items : [];
    // Filtrar productos sin id o sin nombre (defensivo).
    return arr.filter((p) => p && p.id != null && p.nombre);
  }, [inner.items]);

  return {
    items: items,
    loading: !!inner.loading,
    error: inner.err || null,
    setQuery: typeof inner.setQ === 'function' ? inner.setQ : (() => {}),
    query: inner.q || '',
    total: Number(inner.total) || 0,
  };
}
